export enum SortType {
  ASC = 'ASC',
  DESC = 'DESC',
}
